import classNames from 'classnames';
import * as React from 'react';

import { BlockSectionClassResolver } from '../../BlockSection/BlockSectionClassResolver';
import TouchSwiper from '../../ReactComponents/TouchSwiper/TouchSwiper';
import { CallToAction } from '../CallToAction/CallToAction';
import { CallToActionViewModel } from '../CallToAction/CallToActionViewModel.csharp';
import { CallToActionColumnVariant } from './CallToActionColumnVariant.csharp';
import { CallToActionListViewModel } from './CallToActionListViewModel.csharp';

export const CallToActionList = ({ model }: { model: CallToActionListViewModel }) => {
    const renderItems = () => {
        return model.items.map((item: CallToActionViewModel, index: number) => (
            <li className="CallToActionList__Item" key={index}>
                <CallToAction model={item} />
            </li>
        ));
    };

    const classNamesList = classNames(
        'CallToActionList',
        `CallToActionList--${CallToActionColumnVariant[model.columnVariant]}`,
        BlockSectionClassResolver.Resolve(model.blockSectionMargin)
    );

    return (
        <div className={classNamesList}>
            <div className="CallToActionList__Inner">
                <ul className="CallToActionList__Items">
                    {model.columnVariant !== CallToActionColumnVariant.TwoColumns ? (
                        <li className="CallToActionList__Swiper">
                            <TouchSwiper>{renderItems()}</TouchSwiper>
                        </li>
                    ) : (
                        renderItems()
                    )}
                </ul>
            </div>
        </div>
    );
};
